import { render, staticRenderFns } from "./FaxSmall.vue?vue&type=template&id=686372c3&"
import script from "./FaxSmall.vue?vue&type=script&lang=js&"
export * from "./FaxSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports